module.exports = __webpack_public_path__ + "offer-availability-report.svg?f4935acbb82288a0a8e02bbed303bf5d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/offer-availability-report.svg
// module id = 303
// module chunks = 2